import { Group, type GroupProps, Image, Text } from "@mantine/core"
import { IconSunset2 } from "@tabler/icons-react"
import Link from "next/link"
import { useAuth } from "@/hooks"
import { dashboardURL } from "@/utils"

export function Logo(props: GroupProps) {
  const { company } = useAuth()

  return (
    <Link href={dashboardURL} style={{ textDecoration: "none" }}>
      <Group gap={8} wrap="nowrap" align="center" {...props}>
        {company?.logo ? (
          <Image w={24} h={24} radius="sm" src={company.logo} alt={company.name} style={{ objectFit: "cover" }} />
        ) : (
          <IconSunset2 size="1.6rem" color="orange" />
        )}
        {company?.name ? (
          <Text inherit fw={600} flex={1} c="gray.7" tt="capitalize" style={{ wordBreak: "break-word" }}>
            {company.name}
          </Text>
        ) : (
          <Text inherit span variant="gradient" gradient={{ from: "orange", to: "red" }}>
            Team-Tracker
          </Text>
        )}
      </Group>
    </Link>
  )
}
